@if (addressSuggestionExists()) {
  <mat-icon
    class="address-indicator"
    color="accent"
    [id]="id"
    (click)="openAddressOverrideConfirmDialog()"
    [title]="'click for a more accurate address suggestion' | translate">
    error_outline
  </mat-icon>
}
